/* eslint-disable compat/compat */

export const createPollingBroadcastChannel = connectionId => new BroadcastChannel(`polling-${connectionId}`);